import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SvglocationIcon() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.625"
        height="20.625"
        viewBox="0 0 20.625 20.625"
        className="location-new-icon"
      >
        <defs>
          <clipPath id="clipPath">
            <path
              id="path204"
              d="M0-682.665H20.625v20.625H0Z"
              transform="translate(0 682.665)"
            />
          </clipPath>
        </defs>
        <g id="g198" transform="translate(0 682.665)">
          <g id="g200" transform="translate(0 -682.665)">
            <g id="g202" clipPath="url(#clip-path)">
              <g id="g208" transform="translate(7.536 3.722)">
                <path
                  id="path210"
                  d="M-178.263-89.132a2.777,2.777,0,0,1-2.777,2.777,2.777,2.777,0,0,1-2.777-2.777,2.777,2.777,0,0,1,2.777-2.777A2.777,2.777,0,0,1-178.263-89.132Z"
                  transform="translate(183.817 91.909)"
                  fill="none"
                  stroke="#bda770"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.25"
                />
              </g>
              <g id="g212" transform="translate(4.468 0.603)">
                <path
                  id="path214"
                  d="M-337.378-73.536a5.938,5.938,0,0,0-4.666-2.291,5.938,5.938,0,0,0-4.666,2.291,5.647,5.647,0,0,0-.818,5.472,21.287,21.287,0,0,0,3.074,4.932l2.357,3.378.054.077.054-.077,2.357-3.378a21.286,21.286,0,0,0,3.074-4.932A5.647,5.647,0,0,0-337.378-73.536Z"
                  transform="translate(347.888 75.826)"
                  fill="none"
                  stroke="#bda770"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.25"
                />
              </g>
              <g id="g216" transform="translate(4.898 15.517)">
                <path
                  id="path218"
                  d="M-55.148,0l-1.718,1.085,5.414,3.42,5.414-3.42L-47.756,0"
                  transform="translate(56.867)"
                  fill="none"
                  stroke="#bda770"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.25"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
